export const AUTH_TOKEN = 'auth_token';

export const AUTH_TOKEN_EVENT = 'auth_token_event';

export const LOCK_OUT_SHOW_MODAL_EVENT = 'lock_out_show_modal_event';

export const APP_SECRET = 'app_secret';

export const CONFIRM_EMAIL_BANNER = 'confirm_email_banner';
